module.exports = __webpack_public_path__ + "img/modulo-admin.ecbd72e0.svg";